// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IVU7","content":"styles_content__3z4-K","tableWrap":"styles_tableWrap__3loih"};